import { render, staticRenderFns } from "./ChangePassOublie.vue?vue&type=template&id=05350ed8"
import script from "./ChangePassOublie.vue?vue&type=script&lang=js"
export * from "./ChangePassOublie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports